import React, {useContext} from "react";

import { getEntityUrl, getTranslatedEntityLink } from "../util";

import { Link, useStaticQuery, graphql } from "gatsby";
import {SettingsContext} from "../context/SettingsContext";

const LanguageMenu = ({ locales, classes, entity, curLocale, defaultLocale, handleClose, LinkComponent = Link }) => {
    const { settings } = useContext(SettingsContext);

    return <>
        {settings?.Topbar?.languageSelection === 'menu' &&
            (locales?.length > 1 || settings?.Topbar?.pseudoLanguages > 0) &&
            <div key="langList">
                <div className={classes.item} key="empty">&nbsp;</div>
                {
                    locales.map((locale) => {
                        if (locale.code === curLocale) return <React.Fragment key={locale.code} />
                        const link = getTranslatedEntityLink({ locale: locale, defaultLocale, entity });
                        return <LinkComponent key={locale.code} className={classes.item} onClick={handleClose} to={link} component={Link}>
                            {locale.name}
                        </LinkComponent>
                    })
                }
                {settings?.Topbar?.pseudoLanguages?.map(item => {
                    const link = getEntityUrl({ defaultLocale, entity: item });

                    return <LinkComponent key={item.identifier} className={classes.item} onClick={handleClose} to={link} component={Link}>
                        {item.title}
                    </LinkComponent>
                })}
            </div>
        }
    </>
}

export default LanguageMenu;

